import { render, staticRenderFns } from "./helpviewDIS.vue?vue&type=template&id=259402e6"
import script from "./helpviewDIS.vue?vue&type=script&lang=js"
export * from "./helpviewDIS.vue?vue&type=script&lang=js"
import style0 from "./helpviewDIS.vue?vue&type=style&index=0&id=259402e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports